export const PROCESSING_INVOICE_STATUS = 'processing';
export const PAID_INVOICE_STATUS = 'paid';